import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { backToAccountManagement } from '../../../actions/adminActions';

import BackArrowIcon from '../shared/BackArrowIcon';
import RoleIcon from '../shared/RoleIcon';
import TeamIcon from '../shared/TeamIcon';

import AccountRoles from './AccountRoles';
import Teams from '../Teams';
import AccountSubscriptions from './AccountSubscriptions';
import SubscriptionIcon from '../shared/SubscriptionIcon';
import ActivationKeyIcon from '../shared/ActivationKeyIcon';
import AccountActivationKey from './AccountActivationKey/AccountActivationKey';

class AccountDetails extends Component {
  static propTypes = {
    backToAccountManagement: PropTypes.func,
    accountDetail: PropTypes.instanceOf(Object),
  };

  static defaultProps = {
    accountDetail: {},
  };

  state = {
    activeTab: 1,
    showFormError: false,
    successMessage: '',
    activeRolePage: 'ROLES',
    activeTeamPage: 'TEAM',
    activeSubscriptionsPage: 'SUBSCRIPTIONS',
    activeActivationKeyPage: 'ACTIVATION KEY',
  };

  onTabChange = activeTab => {
    const reset = {
      activeRolePage: 'ROLES',
      activeTeamPage: 'TEAM',
      activeSubscriptionsPage: 'SUBSCRIPTIONS',
      activeActivationKeyPage: 'ACTIVATION KEY',
    };
    this.setState({ activeTab, ...reset });
  };

  setActivePage = activePage => {
    const { activeTab } = this.state;
    let activeRolePage = _.cloneDeep(this.state.activeRolePage);
    let activeTeamPage = _.cloneDeep(this.state.activeTeamPage);
    let activeSubscriptionsPage = _.cloneDeep(
      this.state.activeSubscriptionsPage
    );
    let activeActivationKeyPage = _.cloneDeep(
      this.state.activeActivationKeyPage
    );
    if (activeTab === 1) {
      activeTeamPage = activePage;
    } else if (activeTab === 2) {
      activeRolePage = activePage;
    } else if (activeTab === 3) {
      activeSubscriptionsPage = activePage;
    } else if (activeTab === 4) {
      activeActivationKeyPage = activePage;
    }
    this.setState({
      activeRolePage,
      activeTeamPage,
      activeSubscriptionsPage,
      activeActivationKeyPage,
    });
  };

  handleBack = () => {
    const {
      activeRolePage,
      activeTeamPage,
      activeTab,
      activeSubscriptionsPage,
      activeActivationKeyPage,
    } = this.state;
    let isBacktoLanding = false;
    if (activeTab === 1 && activeTeamPage === 'TEAM') {
      isBacktoLanding = true;
    }
    if (activeTab === 2 && activeRolePage === 'ROLES') {
      isBacktoLanding = true;
    }
    if (activeTab === 3 && activeSubscriptionsPage === 'SUBSCRIPTIONS') {
      isBacktoLanding = true;
    }
    if (activeTab === 4 && activeActivationKeyPage === 'ACTIVATION KEY') {
      isBacktoLanding = true;
    }
    if (isBacktoLanding) {
      this.props.backToAccountManagement();
    } else {
      let setPageName = 'TEAM';
      if (activeTab === 1) {
        setPageName = 'TEAM';
      } else if (activeTab === 2) {
        setPageName = 'ROLES';
      } else if (activeTab === 3) {
        setPageName = 'SUBSCRIPTIONS';
      } else if (activeTab === 4) {
        setPageName = 'ACTIVATION KEY';
      }
      this.setActivePage(setPageName);
    }
  };
  updatedActivePage = page => {
    this.setState(page);
  };
  renderTabContent = () => {
    const {
      activeTab,
      activeRolePage,
      activeTeamPage,
      activeSubscriptionsPage,
      activeActivationKeyPage,
    } = this.state;
    const { accountDetail, isSuperUser } = this.props;
    const hasAccess =
      this.props.accountsRights.filter(
        data => data.accountId === accountDetail.accountId && data.accessType
      ).length || isSuperUser;
    let tabs = (
      <Teams
        accountDetail={accountDetail}
        activePage={activeTeamPage}
        setActivePage={this.setActivePage}
        hasAccess={hasAccess}
      />
    );

    if (activeTab === 1) {
      tabs = (
        <Teams
          accountDetail={accountDetail}
          activePage={activeTeamPage}
          setActivePage={this.setActivePage}
          updatedActivePage={this.updatedActivePage}
          hasAccess={hasAccess}
        />
      );
    } else if (activeTab === 2) {
      tabs = (
        <AccountRoles
          accountDetail={accountDetail}
          activePage={activeRolePage}
          setActivePage={this.setActivePage}
          updatedActivePage={this.updatedActivePage}
          hasAccess={hasAccess}
        />
      );
    } else if (activeTab === 3) {
      tabs = (
        <AccountSubscriptions
          accountDetail={accountDetail}
          activePage={activeSubscriptionsPage}
          setActivePage={this.setActivePage}
          updatedActivePage={this.updatedActivePage}
          hasAccess={hasAccess}
        />
      );
    } else if (activeTab === 4) {
      tabs = (
        <AccountActivationKey
          accountDetail={accountDetail}
          activePage={activeActivationKeyPage}
          setActivePage={this.setActivePage}
          updatedActivePage={this.updatedActivePage}
          hasAccess={hasAccess}
        />
      );
    }

    return tabs;
  };

  render() {
    const { activeTab, showFormError, successMessage } = this.state;
    const { accountDetail } = this.props;
    if (_.isEmpty(accountDetail)) {
      return <div>loading...</div>;
    }
    return (
      <div className="accounts-details">
        <div className="back-button">
          <button
            onClick={this.handleBack}
            className="accounts-details-card-button"
          >
            <BackArrowIcon />
            <span>Back</span>
          </button>
        </div>
        <div className="accounts-details-card">
          <div className="accounts-details-card-header">
            <h1 className="accounts-details-card-title">
              Account Details
              <span className="accounts-name">
                {accountDetail.accountType === 'TPP'
                  ? accountDetail.accountName + ' ' + '(Third Party)'
                  : accountDetail.accountName}
              </span>
            </h1>
          </div>
          <div className="accounts-details-card-body">
            <div className="custom-tab">
              <div className="custom-tab--navigation">
                <ul className="custom-tab--nav">
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 1 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(1)}
                      className="custom-tab--nav-link"
                    >
                      <TeamIcon /> Teams
                    </button>
                  </li>
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 2 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(2)}
                      className="custom-tab--nav-link"
                    >
                      <RoleIcon /> Roles
                    </button>
                  </li>
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 3 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(3)}
                      className="custom-tab--nav-link"
                    >
                      <SubscriptionIcon /> Subscriptions
                    </button>
                  </li>
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 4 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(4)}
                      className="custom-tab--nav-link"
                    >
                      <ActivationKeyIcon /> Activation Key
                    </button>
                  </li>
                </ul>
                {showFormError && (
                  <div className="error-message">{showFormError}</div>
                )}
                {successMessage && (
                  <div className="success-message">{successMessage}</div>
                )}
              </div>
              <div className="custom-tab--body">{this.renderTabContent()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ admin, login }) => {
  const { accountDetailsData } = admin;
  return {
    accountDetail: accountDetailsData,
    accountsRights: login.loginResponse.data.accounts,
    isSuperUser: login.loginResponse.data.ss0mm,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    backToAccountManagement: bindActionCreators(
      backToAccountManagement,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails);
